// Cart Subscribe & Save functionality (handles ui)
 
(function() {
  'use strict';
  
  window.SubscribeSave = window.SubscribeSave || {};

  // eligibility
  function isProductEligible(productTitle, productType, properties, item) {
    if (properties && (properties['Subscribe & Save'] === 'true')) {
      return true;
    }
    
    if (window.BARREL && window.BARREL.cart && window.BARREL.cart.items) {
      const lineKey = item.getAttribute('data-line-key');
      const cartItem = window.BARREL.cart.items.find(i => i.key === lineKey);
      if (cartItem && (cartItem.selling_plan_allocation || cartItem.selling_plan)) {
        return true;
      }
    }
    
    if (item.querySelector('[data-selling-plan], [data-selling-plan-id], input[data-selling-plan]')) {
      return true;
    }
    
    return false;
  }

  function getDynamicIntervals() {
    
    if (window.SubscribeSave && Array.isArray(window.SubscribeSave.intervals) && window.SubscribeSave.intervals.length) {
      return window.SubscribeSave.intervals;
    }
    
    if (window.BARREL && window.BARREL.cart && window.BARREL.cart.items) {
      
      const subscriptionItem = window.BARREL.cart.items.find(item => 
        item.properties && (item.properties['Subscribe & Save'] === 'true' || item.properties['purchase_type'] === 'autodeliver')
      );
      
      if (subscriptionItem && subscriptionItem.selling_plan_allocation) {
        
        const sellingPlan = subscriptionItem.selling_plan_allocation.selling_plan;
        if (sellingPlan && sellingPlan.options && sellingPlan.options.length > 0) {
          const intervalOption = sellingPlan.options[0];
          if (intervalOption.values && intervalOption.values.length > 0) {
        
            return intervalOption.values.map(value => {
              const match = value.match(/(\d+)\s*days?/i);
              if (match) {
                return `${match[1]} Days`;
              }
              return value;
            });
          }
        }
      }
    }
    
    return ['45 Days', '60 Days', '75 Days', '90 Days', '120 Days'];
  }
 
  // subscribe & save UI
  function createSubscribeSaveUI(item, isSubscribed = false, selectedInterval = '45 Days', intervals) {
    
    intervals = intervals || getDynamicIntervals();
 
    const optionsHtml = intervals.map(interval => `
      <option value="${interval}"${interval === selectedInterval ? ' selected' : ''}>${interval}</option>
    `).join('');

    return `
      <div class="subscribe-save-cart-ui">
        <label class="subscribe-save-label">
          <input type="checkbox" 
                 class="subscribe-save-checkbox" 
                 style="width: 16px; height: 16px; margin: 0; cursor: pointer;"
                 ${isSubscribed ? 'checked' : ''}
                 data-line-key="${item.key || ''}"
                 data-variant-id="${item.variant_id || ''}"
          >
          <span class="subscribe-save-text">
            ${isSubscribed ? 'Subscribed' : 'Subscribe & Save <span class="subscribe-save-discount" style="color: #174aff; font-weight: bold;">20%</span>'}
          </span>
        </label>
        <div class="subscribe-save-dropdown-wrap" style="display: ${isSubscribed ? 'block' : 'none'}; margin-top: 5px;">
          <select class="subscribe-dropdown" style="width: 100%; padding: 4px 8px;">
            ${optionsHtml}
          </select>
        </div>
      </div>
    `;
  }

    // checkbox toggle 
  async function handleSubscribeToggle(checkbox) {
    // Prevent multiple simultaneous operations
    if (window.isUpdatingSubscription) return;
    window.isUpdatingSubscription = true;
    
    checkbox.setAttribute('data-user-interacted', 'true');
    
    // Save user's subscription choice to cache 
    const itemKey = checkbox.dataset.lineKey;
    if (itemKey && window.setSubscriptionCache) {
      window.setSubscriptionCache(itemKey, checkbox.checked);
    }
    
    const dropdownWrap = checkbox.closest('.subscribe-save-cart-ui').querySelector('.subscribe-save-dropdown-wrap');
    const textSpan = checkbox.closest('.subscribe-save-cart-ui').querySelector('.subscribe-save-text');
    const cartItem = checkbox.closest('.mini-cart__item');
    const priceElement = cartItem.querySelector('.product-price');
    const quantityInput = cartItem.querySelector('.item__quantity');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
  
    if (checkbox.checked) {
      dropdownWrap.style.display = 'block';
      textSpan.innerHTML = 'Subscribed';

      // Set the original price attribute if not already set
      if (!priceElement.getAttribute('data-original-price')) {
        const priceSpan = priceElement.querySelector('.discounted-price');
        if (priceSpan) {
          const priceText = priceSpan.textContent.trim();
          const priceMatch = priceText.match(/\$([\d,]+\.?\d*)/);
          if (priceMatch) {
            const total = parseFloat(priceMatch[1].replace(',', ''));
            const unit = total / quantity;
            priceElement.setAttribute('data-original-price', `$${unit.toFixed(2)}`);
          }
        }
      }

      updateItemPrice(priceElement, true);
      
      // Get the selected interval and update the cart with selling plan
      const dropdown = dropdownWrap.querySelector('.subscribe-dropdown');
      if (dropdown && dropdown.value) {
        await handleIntervalChange(dropdown);
      }
    } else {
      dropdownWrap.style.display = 'none';
      textSpan.innerHTML = 'Subscribe & Save <span class="subscribe-save-discount">20%</span>';

      updateItemPrice(priceElement, false);
      
      // Remove selling plan from cart item
      try {
        const updateResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: itemKey,
            selling_plan: ''
          })
        });
        
        if (updateResponse.ok) {
          // Get the updated cart data
          const cartResponse = await fetch('/cart.js');
          if (cartResponse.ok) {
            const cartData = await cartResponse.json();
            
            // Update the cart display without full page refresh
            if (window.cart && typeof window.cart.get === 'function') {
              window.cart.get().then((data) => {
                if (window.state) {
                  window.state.cart = data;
                }
                
                // Trigger cart update event
                if (typeof window.trigger === 'function') {
                  window.trigger('cart:updated', document.body, data);
                }
              });
            } else {
              // Fallback: trigger cart update event
              document.dispatchEvent(new Event('cart:updated'));
            }
          }
        }
        
        // Sync the cart display to ensure it matches the actual cart data
        setTimeout(() => {
          window.SubscribeSave.syncCartDisplay();
        }, 100);
      } catch (error) {
        console.error('Error removing selling plan:', error);
      }
    }

    updateCartSubtotal();

    if (window.updateShippingCalculator) {
      window.updateShippingCalculator();
    }
    
    // Reset flag after operation completes
    window.isUpdatingSubscription = false;
  }

  // Debounce mechanism to prevent infinite loops
  let updateItemPriceTimeout = null;
  let isUpdatingPrices = false;

    function updateItemPrice(priceElement, isSubscribed) {
    if (!priceElement) return;
    
    // Prevent circular updates when already updating prices
    if (isUpdatingPrices) {
      return;
    }
    
    // Clear any existing timeout
    if (updateItemPriceTimeout) {
      clearTimeout(updateItemPriceTimeout);
    }
    
    // Debounce the update to prevent rapid successive calls
    updateItemPriceTimeout = setTimeout(() => {
      updateItemPriceInternal(priceElement, isSubscribed);
    }, 50);
  }
  
  function updateItemPriceInternal(priceElement, isSubscribed) {
    if (!priceElement) return;
    
    // Set flag to prevent circular updates
    isUpdatingPrices = true;
    
    try {
      const cartItem = priceElement.closest('.mini-cart__item');
      const quantityInput = cartItem ? cartItem.querySelector('.item__quantity') : null;
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      const originalPriceText = priceElement.getAttribute('data-original-price');
      
      if (!originalPriceText) {
        return;
      }

      // Check if the element already has the correct structure from drawer-cart.js
      const existingDiscountedPrice = priceElement.querySelector('.discounted-price');
      const existingOriginalPrice = priceElement.querySelector('.original-price');
      
      const priceMatch = originalPriceText.match(/\$([\d,]+\.?\d*)/);
      if (priceMatch) {
        const originalUnitAmount = parseFloat(priceMatch[1].replace(',', ''));
        const originalAmount = originalUnitAmount * quantity;
        
        if (isSubscribed) {
          // Check if this item has a selling plan allocation (real subscription)
          const cartItem = priceElement.closest('.mini-cart__item');
          const lineKey = cartItem?.getAttribute('data-line-key');
          
          if (lineKey && window.cartData && window.cartData.items) {
            const cartItemData = window.cartData.items.find(item => item.key === lineKey);
            
            if (cartItemData && cartItemData.selling_plan_allocation) {
              // Use actual selling plan pricing instead of manual calculation
              const sellingPlanDiscountedTotal = (cartItemData.selling_plan_allocation.per_delivery_price * quantity) / 100;
              
              // Get the true original price from the data attribute (set by syncCartDisplay)
              const trueOriginalPriceText = priceElement.getAttribute('data-original-price');
              let originalTotalPrice;
              
              if (trueOriginalPriceText && trueOriginalPriceText !== 'Loading...') {
                const priceMatch = trueOriginalPriceText.match(/\$([\d,]+\.?\d*)/);
                if (priceMatch) {
                  const trueOriginalUnitPrice = parseFloat(priceMatch[1].replace(',', ''));
                  originalTotalPrice = `$${(trueOriginalUnitPrice * quantity).toFixed(2)}`;
                } else {
                  originalTotalPrice = `$${originalAmount.toFixed(2)}`;
                }
              } else {
                originalTotalPrice = `$${originalAmount.toFixed(2)}`;
              }
              
              // Update price display with selling plan pricing
              if (existingDiscountedPrice && existingOriginalPrice) {
                if (existingDiscountedPrice.textContent !== `$${sellingPlanDiscountedTotal.toFixed(2)}`) {
                  existingDiscountedPrice.textContent = `$${sellingPlanDiscountedTotal.toFixed(2)}`;
                }
                if (existingOriginalPrice.textContent !== originalTotalPrice) {
                  existingOriginalPrice.textContent = originalTotalPrice;
                }
              } else {
                priceElement.innerHTML = `<span class="discounted-price">$${sellingPlanDiscountedTotal.toFixed(2)}</span> <span class="original-price">${originalTotalPrice}</span>`;
              }
              return; // Exit early, don't use manual calculation
            }
          }
          
          // Fallback to manual 20% calculation if no selling plan found
          const discountedAmount = originalUnitAmount * 0.8 * quantity;
          const discountedPrice = `$${discountedAmount.toFixed(2)}`;
          const originalTotalPrice = `$${originalAmount.toFixed(2)}`;
          
          // If elements already exist with correct prices, just update the text content to avoid layout shift
          if (existingDiscountedPrice && existingOriginalPrice) {
            if (existingDiscountedPrice.textContent !== discountedPrice) {
              existingDiscountedPrice.textContent = discountedPrice;
            }
            if (existingOriginalPrice.textContent !== originalTotalPrice) {
              existingOriginalPrice.textContent = originalTotalPrice;
            }
          } else {
            // Only recreate if structure doesn't exist
            priceElement.innerHTML = `<span class="discounted-price">${discountedPrice}</span> <span class="original-price">${originalTotalPrice}</span>`;
          }
        } else {
          const originalTotalPrice = `$${originalAmount.toFixed(2)}`;
          
          if (existingDiscountedPrice && !existingOriginalPrice) {
            if (existingDiscountedPrice.textContent !== originalTotalPrice) {
              existingDiscountedPrice.textContent = originalTotalPrice;
            }
          } else {
            priceElement.innerHTML = `<span class="discounted-price">${originalTotalPrice}</span>`;
          }
        }
      }
    } finally {
      // Reset flag to allow future price updates
      isUpdatingPrices = false;
    }
  }

  function updateCartSubtotal() {
    const subtotalElement = document.querySelector('.subtotal-price');
    if (!subtotalElement) return;
    
    let total = 0;
    const cartItems = document.querySelectorAll('.mini-cart__item');
    
    cartItems.forEach(item => {
      const priceElement = item.querySelector('.product-price');
      if (priceElement) {
        const priceSpan = priceElement.querySelector('.discounted-price');
        if (priceSpan) {
          const priceText = priceSpan.textContent.trim();
          const priceMatch = priceText.match(/\$([\d,]+\.?\d*)/);
          if (priceMatch) {
            const amount = parseFloat(priceMatch[1].replace(',', ''));
            total += amount;
          }
        }
      }
    });
    
    if (total > 0) {
      subtotalElement.textContent = `$${total.toFixed(2)}`;
    }

    if (window.updateShippingCalculator) {
      window.updateShippingCalculator();
    }
  }

  // Function to sync cart display with actual cart data
  let isSyncingCart = false;
  
  async function syncCartDisplay() {
    // Prevent recursive calls
    if (isSyncingCart) {
      return;
    }
    
    isSyncingCart = true;
    
    try {
      const response = await fetch('/cart.js');
      if (response.ok) {
        const cartData = await response.json();
        
        // Store cart data globally for other functions to use
        window.cartData = cartData;
        
        // Pre-fetch product data for accurate pricing
        await preFetchProductPrices(cartData);
        
        // Update each cart item to reflect the actual selling plan pricing
        cartData.items.forEach(cartItem => {
          const domItem = document.querySelector(`[data-line-key="${cartItem.key}"]`);
          if (domItem) {
            const priceElement = domItem.querySelector('.product-price');
            if (priceElement) {
              if (cartItem.selling_plan_allocation) {
                // For subscription items, use the pre-fetched true original variant price
                const productHandle = domItem.querySelector('a[href*="/products/"]')?.href?.split('/products/')[1]?.split('?')[0];
                if (productHandle && window.productVariantPriceCache) {
                  const cacheKey = `${productHandle}_${cartItem.variant_id}`;
                  const trueOriginalUnitPrice = window.productVariantPriceCache[cacheKey];
                  
                  if (trueOriginalUnitPrice) {
                    // Use the true original price from product data
                    const discountedTotal = (cartItem.selling_plan_allocation.per_delivery_price * cartItem.quantity) / 100;
                    const originalTotal = trueOriginalUnitPrice * cartItem.quantity;
                    
                    priceElement.innerHTML = `<span class="discounted-price">$${discountedTotal.toFixed(2)}</span> <span class="original-price">$${originalTotal.toFixed(2)}</span>`;
                    priceElement.setAttribute('data-original-price', `$${trueOriginalUnitPrice.toFixed(2)}`);
                  } else {
                    // Fallback: use current logic if cache miss
                    const discountedTotal = (cartItem.selling_plan_allocation.per_delivery_price * cartItem.quantity) / 100;
                    const originalTotal = (cartItem.original_price * cartItem.quantity) / 100;
                    
                    priceElement.innerHTML = `<span class="discounted-price">$${discountedTotal.toFixed(2)}</span> <span class="original-price">$${originalTotal.toFixed(2)}</span>`;
                  }
                } else {
                  // Fallback: use current logic if no product handle
                  const discountedTotal = (cartItem.selling_plan_allocation.per_delivery_price * cartItem.quantity) / 100;
                  const originalTotal = (cartItem.original_price * cartItem.quantity) / 100;
                  
                  priceElement.innerHTML = `<span class="discounted-price">$${discountedTotal.toFixed(2)}</span> <span class="original-price">$${originalTotal.toFixed(2)}</span>`;
                }
              } else {
                // For regular items, show single price
                const originalTotal = (cartItem.original_price * cartItem.quantity) / 100;
                priceElement.innerHTML = `<span class="discounted-price">$${originalTotal.toFixed(2)}</span>`;
                priceElement.setAttribute('data-original-price', `$${originalTotal.toFixed(2)}`);
              }
            }
          }
        });
        
        // Update subtotal
        updateCartSubtotal();
        
        // Check if any items that should be subscriptions are missing selling plans
        // Only check if we're not already in a fixing process
        if (!window.isFixingSellingPlans) {
          await checkAndFixMissingSellingPlans(cartData);
        }
      }
    } catch (error) {
      console.error('Error syncing cart display:', error);
    } finally {
      isSyncingCart = false;
    }
  }

  // Function to pre-fetch product data for accurate pricing
  async function preFetchProductPrices(cartData) {
    const productPromises = [];
    
    for (const cartItem of cartData.items) {
      if (cartItem.selling_plan_allocation) {
        const domItem = document.querySelector(`[data-line-key="${cartItem.key}"]`);
        if (domItem) {
          const productHandle = domItem.querySelector('a[href*="/products/"]')?.href?.split('/products/')[1]?.split('?')[0];
          if (productHandle && !window.productVariantPriceCache) {
            window.productVariantPriceCache = {};
          }
          
          if (productHandle && window.productVariantPriceCache) {
            const cacheKey = `${productHandle}_${cartItem.variant_id}`;
            if (!window.productVariantPriceCache[cacheKey]) {
              productPromises.push(
                fetch(`/products/${productHandle}.js`)
                  .then(res => res.json())
                  .then(productData => {
                    const variant = productData.variants.find(v => v.id == cartItem.variant_id);
                    if (variant) {
                      const truePrice = variant.price / 100; // Convert from cents
                      window.productVariantPriceCache[cacheKey] = truePrice;
                      return { cartItemKey: cartItem.key, truePrice };
                    }
                  })
                  .catch(error => {
                    console.error(`Error pre-fetching product data for ${productHandle}:`, error);
                  })
              );
            }
          }
        }
      }
    }
    
    // Wait for all product data to be fetched
    if (productPromises.length > 0) {
      await Promise.all(productPromises);
    }
  }

  // Function to check and fix missing selling plans for subscription items
  async function checkAndFixMissingSellingPlans(cartData) {
    // Prevent recursive calls
    if (window.isFixingSellingPlans) {
      return;
    }
    
    window.isFixingSellingPlans = true;
    
    try {
      for (const cartItem of cartData.items) {
        // Check if this item should be a subscription but doesn't have a selling plan
        const domItem = document.querySelector(`[data-line-key="${cartItem.key}"]`);
        if (domItem) {
          const subscribeCheckbox = domItem.querySelector('.subscribe-save-checkbox');
          const isChecked = subscribeCheckbox && subscribeCheckbox.checked;
          
          if (isChecked && !cartItem.selling_plan_allocation) {
            // Get the selected interval
            const dropdown = domItem.querySelector('.subscribe-dropdown');
            if (dropdown && dropdown.value) {
              // Check if the value is a selling plan ID (numeric) or interval text
              let intervalText = dropdown.value;
              let sellingPlanId = null;
              
              if (/^\d+$/.test(dropdown.value)) {
                // Value is a selling plan ID, use it directly
                sellingPlanId = parseInt(dropdown.value);
              } else {
                // Value is interval text, find the corresponding selling plan ID
                try {
                  const productHandle = domItem.querySelector('a[href*="/products/"]')?.href?.split('/products/')[1]?.split('?')[0];
                  if (productHandle) {
                    const response = await fetch(`/products/${productHandle}.js`);
                    if (response.ok) {
                      const productData = await response.json();
                      
                      // Find the selling plan that matches the interval
                      if (productData.selling_plan_groups && productData.selling_plan_groups.length > 0) {
                        for (const group of productData.selling_plan_groups) {
                          if (group.selling_plans) {
                            for (const plan of group.selling_plans) {
                              if (plan.name && plan.name.toLowerCase().includes(intervalText.toLowerCase().replace(' days', ''))) {
                                sellingPlanId = plan.id;
                                break;
                              }
                            }
                            if (sellingPlanId) break;
                          }
                        }
                      }
                    }
                  }
                } catch (error) {
                  console.error(`Error finding selling plan for interval ${intervalText}:`, error);
                }
              }
              
              if (sellingPlanId) {
                try {
                  // Update the cart item with the selling plan
                  const updateResponse = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      id: cartItem.key,
                      selling_plan: sellingPlanId
                    })
                  });
                  
                  if (!updateResponse.ok) {
                    console.error(`Failed to add selling plan to ${cartItem.title}`);
                  }
                } catch (error) {
                  console.error(`Error adding selling plan to ${cartItem.title}:`, error);
                }
              }
            }
          }
        }
      }
    } finally {
      window.isFixingSellingPlans = false;
    }
  }

    async function handleIntervalChange(select) {
    // Prevent multiple simultaneous operations
    if (window.isUpdatingSubscription) return;
    window.isUpdatingSubscription = true;
    
    select.setAttribute('data-user-interacted', 'true');
    const subscribeSaveUI = select.closest('.subscribe-save-cart-ui');
    if (subscribeSaveUI) {
      const checkbox = subscribeSaveUI.querySelector('.subscribe-save-checkbox');
      if (checkbox) {
        checkbox.setAttribute('data-user-interacted', 'true');
        
        // Save user's subscription choice to cache when they change interval
        const itemKey = checkbox.dataset.lineKey;
        if (itemKey && window.setSubscriptionCache) {
          window.setSubscriptionCache(itemKey, checkbox.checked);
        }
      }
    }
    
    const interval = select.value;
    const cartItem = select.closest('.mini-cart__item');
    if (!cartItem) {
      return;
    }
    
    try {
      // Find the selling plan ID for the new interval
      const productHandle = cartItem.querySelector('a[href*="/products/"]')?.href?.split('/products/')[1]?.split('?')[0];
      if (!productHandle) {
        return;
      }
      
      // Fetch product data to get selling plan ID
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) {
        return;
      }
      
      const productData = await response.json();
      let sellingPlanId = null;
      
      // Find the selling plan that matches the new interval
      if (productData.selling_plan_groups && productData.selling_plan_groups.length > 0) {
        for (const group of productData.selling_plan_groups) {
          if (group.selling_plans) {
            for (const plan of group.selling_plans) {
              if (plan.name && plan.name.toLowerCase().includes(interval.toLowerCase().replace(' days', ''))) {
                sellingPlanId = plan.id;
                break;
              }
            }
            if (sellingPlanId) break;
          }
        }
      }
      
      if (sellingPlanId) {
        // Update the cart item with the new selling plan
        const lineKey = select.dataset.lineKey;
        const updateResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: lineKey,
            selling_plan: sellingPlanId
          })
        });
        
        if (updateResponse.ok) {
          // Get the updated cart data
          const cartResponse = await fetch('/cart.js');
          if (cartResponse.ok) {
            const cartData = await cartResponse.json();
            
            // Update the cart display without full page refresh
            if (window.cart && typeof window.cart.get === 'function') {
              window.cart.get().then((data) => {
                if (window.state) {
                  window.state.cart = data;
                }
                
                // Trigger cart update event
                if (typeof window.trigger === 'function') {
                  window.trigger('cart:updated', document.body, data);
                }
              });
            } else {
              // Fallback: trigger cart update event
              document.dispatchEvent(new Event('cart:updated'));
            }
          }
        }
        
        // Sync the cart display to ensure it matches the actual cart data
        setTimeout(() => {
          window.SubscribeSave.syncCartDisplay();
        }, 100);
      }
    } catch (error) {
      console.error('Error updating interval:', error);
    }

    updateCartSubtotal();
    
    // Reset flag after operation completes
    window.isUpdatingSubscription = false;
  }

  function hasSubscriptionItems() {

    const cartItems = document.querySelectorAll('.mini-cart__item');
    for (let item of cartItems) {
      const sellingPlanText = item.querySelector('.opacity-60');
      if (sellingPlanText && sellingPlanText.textContent.toLowerCase().includes('every')) {
        return true;
      }

      const itemText = item.textContent.toLowerCase();
      if (itemText.includes('subscription') || itemText.includes('recurring') || itemText.includes('subscribe')) {
        return true;
      }
    }
    return false;
  }

  function debounce(fn, delay) {
    let timer = null;
    return function(...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  function injectSubscribeSaveUI(item, lineKey, variantId, dynamicIntervals) {

    if (!item) {
      const cartItems = document.querySelectorAll('.mini-cart__item');
      cartItems.forEach(cartItem => {
        const lineKey = cartItem.getAttribute('data-line-key') || cartItem.querySelector('.item__line-key')?.value || '';
        const variantId = cartItem.querySelector('.item__line-key')?.value || '';
        injectSubscribeSaveUI(cartItem, lineKey, variantId, dynamicIntervals);
      });
      return;
    }
    
    // if already interacted with this item
    const existingCheckbox = item.querySelector('.subscribe-save-checkbox');
    const userHasInteracted = existingCheckbox && existingCheckbox.hasAttribute('data-user-interacted');
    const userChoice = userHasInteracted ? existingCheckbox.checked : null;
    
    const existingUI = item.querySelector('.subscribe-save-cart-ui');
    if (!existingUI) {
    
      const actualInterval = getItemInterval(item);
      const isSubscribed = checkIfItemIsSubscribed(item);
    
      // Prioritize user interaction, then subscription detection
      const shouldBeSubscribed = userHasInteracted ? userChoice : isSubscribed;
    
      let finalInterval = actualInterval;
      if (isSubscribed && actualInterval === '45 Days') {
    
        const lineKey = item.getAttribute('data-line-key');
        if (lineKey && window.cartData && window.cartData.items) {
          const cartItem = window.cartData.items.find(i => i.key === lineKey);
          if (cartItem && cartItem.properties && cartItem.properties['Delivery']) {
            finalInterval = cartItem.properties['Delivery'];
          }
        }
      }
      
      const uiHTML = createSubscribeSaveUI({ key: lineKey, variant_id: variantId }, shouldBeSubscribed, finalInterval, dynamicIntervals);
      const infoDiv = item.querySelector('.item__info');
      if (infoDiv) {
        infoDiv.insertAdjacentHTML('beforeend', uiHTML);
        
        if (userHasInteracted) {
          const newCheckbox = item.querySelector('.subscribe-save-checkbox');
          if (newCheckbox) {
            newCheckbox.setAttribute('data-user-interacted', 'true');
          }
        }
        
        if (isSubscribed && !userHasInteracted) {
          const newCheckbox = item.querySelector('.subscribe-save-checkbox');
          const newSelect = item.querySelector('.subscribe-dropdown');
          if (newCheckbox) {
            newCheckbox.setAttribute('data-user-interacted', 'true');
          }
          if (newSelect) {
            newSelect.setAttribute('data-user-interacted', 'true');
        
            if (finalInterval && finalInterval !== '45 Days') {
              newSelect.value = finalInterval;
            }
          } 
        }
        
        if (isSubscribed) {
          const select = item.querySelector('.subscribe-dropdown');
          const checkbox = item.querySelector('.subscribe-save-checkbox');
          if (select && !select.hasAttribute('data-user-interacted')) {
            select.setAttribute('data-user-interacted', 'true');
          }
          if (checkbox && !checkbox.hasAttribute('data-user-interacted')) {
            checkbox.setAttribute('data-user-interacted', 'true');
          }
        }
        
        if (isSubscribed) {
          const select = item.querySelector('.subscribe-dropdown');
          if (select) {
            const correctInterval = getItemInterval(item);
            
            if (correctInterval && correctInterval !== '45 Days') {
        
              setTimeout(() => {
                select.value = correctInterval;
        
                Array.from(select.options).forEach(option => {
                  option.selected = option.value === correctInterval;
                });
              }, 100);
            }
          }
        }
        
      }
    }
  }

  function injectSubscribeSaveUIWithEligibilityCheck() {
    const cartItems = document.querySelectorAll('.mini-cart__item');
    cartItems.forEach(item => {
      let infoDiv = item.querySelector('.item__info');
      if (!infoDiv) return;
      let productTitle = infoDiv.querySelector('.product-title a')?.textContent || '';
      let productType = item.getAttribute('data-product-type') || '';
      let lineKey = item.getAttribute('data-line-key') || '';
      let variantId = item.querySelector('.item__line-key')?.value || '';
      let properties = {};
      item.querySelectorAll('[data-property]').forEach(function(prop) {
        properties[prop.getAttribute('data-property')] = prop.textContent;
      });
      // Use the robust eligibility function
      const isEligible = isProductEligible(productTitle, productType, properties, item);
      // Set data-subscription-eligible attribute for CSS/debugging
      item.setAttribute('data-subscription-eligible', isEligible ? 'true' : 'false');
      if (!isEligible) {
        const existingUI = item.querySelector('.subscribe-save-cart-ui');
        if (existingUI) existingUI.remove();
        return;
      }
      const existingUI = item.querySelector('.subscribe-save-cart-ui');
      if (!existingUI) {
        // Check if item should be subscribed based on explicit intent or user choice
        const isSubscribed = checkIfItemIsSubscribed(item);
        const actualInterval = getItemInterval(item);
        const uiHTML = createSubscribeSaveUI({ key: lineKey, variant_id: variantId }, isSubscribed, actualInterval, getDynamicIntervals());
        infoDiv.insertAdjacentHTML('beforeend', uiHTML);
      }
    });
  }

  function checkIfItemIsSubscribed(item) {
    const lineKey = item.getAttribute('data-line-key');
    
    // First, check if user has made an explicit choice (cached state)
    if (lineKey && window.getSubscriptionCache) {
      const cachedState = window.getSubscriptionCache(lineKey);
      if (cachedState !== null) {
        return cachedState;
      }
    }
    
    // Then check for explicit subscription properties (PLP/PDP subscription intent)
    const properties = item.querySelectorAll('[data-property]');
    for (let prop of properties) {
      const key = prop.getAttribute('data-property');
      const value = prop.textContent;
      if (key === 'Subscribe & Save' && value === 'true') {
        return true;
      }
      if (key === 'purchase_type' && value === 'autodeliver') {
        return true;
      }
    }
    
    // Check cart data for subscription properties
    if (lineKey && window.cartData && window.cartData.items) {
      const cartItem = window.cartData.items.find(i => i.key === lineKey);
      if (cartItem && cartItem.properties) {
        if (cartItem.properties['Subscribe & Save'] === 'true' || 
            cartItem.properties['purchase_type'] === 'autodeliver') {
          return true;
        }
        
        // Check for delivery interval (but only if not explicitly one-time)
        if (cartItem.properties['Delivery'] && cartItem.properties['purchase_type'] !== 'onetime') {
          return true;
        }
      }
    }
    
    // DO NOT auto-subscribe items that only have selling_plan_allocation or other generic indicators
    // This prevents slider items from being automatically subscribed
    return false;
  }
  
  function getItemInterval(item) {
    
    const properties = item.querySelectorAll('[data-property]');
    for (let prop of properties) {
      const key = prop.getAttribute('data-property');
      const value = prop.textContent || prop.value; // Check both textContent and value
      if (key === 'Delivery') {
        return value;
      }
    }
    
    const lineKey = item.getAttribute('data-line-key');
    if (lineKey && window.cartData && window.cartData.items) {
      const cartItem = window.cartData.items.find(i => i.key === lineKey);
      if (cartItem && cartItem.properties && cartItem.properties['Delivery']) {
        return cartItem.properties['Delivery'];
      }
    }
    
    const interval = item.getAttribute('data-interval') || 
                    item.querySelector('[data-interval]')?.getAttribute('data-interval');
    
    if (interval) {
      return interval;
    }
    
    const sellingPlanText = item.querySelector('.opacity-60');
    if (sellingPlanText) {
      const text = sellingPlanText.textContent;
      const intervalMatch = text.match(/every\s+(\d+\s+days?)/i);
      if (intervalMatch) {
        return intervalMatch[1];
      }
    }
    
    return '45 Days';
  }

  function init() {
    
    const style = document.createElement('style');
    style.textContent = `
      .mini-cart__item[data-subscription-eligible="false"] .subscribe-save-cart-ui {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
    
    injectSubscribeSaveUI();
    updateSubscriptionPrices();
    
    // Initial sync of cart display to ensure all items have proper attributes
    if (!window.initialSyncPerformed) {
      window.initialSyncPerformed = true;
      setTimeout(() => {
        syncCartDisplay();
      }, 500);
    }
    
    const cartContainers = [
      ...document.querySelectorAll('.cart-grid-items-wrap, .mini-cart__items, .cart__items__content')
    ];
    const debouncedUpdate = debounce(() => {
      injectSubscribeSaveUI();
      updateSubscriptionPrices();
      // Sync cart display after UI updates (only if not already syncing)
      if (!isSyncingCart) {
        setTimeout(() => {
          syncCartDisplay();
        }, 100);
      }
    }, 300);
    cartContainers.forEach(cartContainer => {
      if (cartContainer) {
        const observer = new MutationObserver(function(mutations) {
          let shouldUpdate = false;
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              shouldUpdate = true;
            }
          });
          if (shouldUpdate) debouncedUpdate();
        });
        observer.observe(cartContainer, {
          childList: true,
          subtree: true
        });
      }
    });
  }

  function updateSubscriptionPrices() {
    const cartItems = document.querySelectorAll('.mini-cart__item');
    
    cartItems.forEach(item => {
      const isSubscribed = checkIfItemIsSubscribed(item);
      const checkbox = item.querySelector('.subscribe-save-checkbox');
      const dropdownWrap = item.querySelector('.subscribe-save-dropdown-wrap');
      const textSpan = item.querySelector('.subscribe-save-text');
      const select = item.querySelector('.subscribe-dropdown');
      
      if (isSubscribed && select && !select.hasAttribute('data-user-interacted')) {
        select.setAttribute('data-user-interacted', 'true');
      }
      
      if (isSubscribed && select && !select.hasAttribute('data-user-interacted')) {
        const correctInterval = getItemInterval(item);
        if (correctInterval && correctInterval !== '45 Days' && select.value !== correctInterval) {
          select.value = correctInterval;
        }
      }
      
      const userHasInteracted = checkbox && checkbox.hasAttribute('data-user-interacted');
      
      if (isSubscribed && !userHasInteracted) {
      
        const priceElement = item.querySelector('.product-price');
        if (priceElement) {
          
          const currentPriceText = priceElement.textContent.trim();
          if (!priceElement.getAttribute('data-original-price')) {
            priceElement.setAttribute('data-original-price', currentPriceText);
          }
          updateItemPrice(priceElement, true);
        }
        
        if (checkbox && !checkbox.checked) {
          checkbox.checked = true;
        }
        if (dropdownWrap && checkbox && checkbox.checked) {
          dropdownWrap.style.display = 'block';
        }
        if (textSpan && checkbox && checkbox.checked) {
          textSpan.innerHTML = 'Subscribed';
        }
        if (select) {
          const selectedInterval = getItemInterval(item);
          if (selectedInterval && !select.hasAttribute('data-user-interacted')) {
            select.value = selectedInterval;
          }
        }
      } else if (userHasInteracted) {
        
        const priceElement = item.querySelector('.product-price');
        if (priceElement) {
          updateItemPrice(priceElement, checkbox.checked);
        }
        
        if (dropdownWrap) {
          dropdownWrap.style.display = checkbox.checked ? 'block' : 'none';
        }
        if (textSpan) {
          textSpan.innerHTML = checkbox.checked ? 'Subscribed' : 'Subscribe & Save <span class="subscribe-save-discount">20%</span>';
        }
      }
    });
    
    updateCartSubtotal();

    if (window.updateShippingCalculator) {
      window.updateShippingCalculator();
    }
  }

  window.SubscribeSave = {
    init: init,
    injectSubscribeSaveUI: injectSubscribeSaveUI,
    test: function() {
      injectSubscribeSaveUI();
    },
    updateCartSubtotal: updateCartSubtotal,
    updateItemPrice: updateItemPrice,
    handleSubscribeToggle: handleSubscribeToggle,
    syncCartDisplay: syncCartDisplay,

    checkMissingSellingPlans: async function() {
      const response = await fetch('/cart.js');
      if (response.ok) {
        const cartData = await response.json();
        await checkAndFixMissingSellingPlans(cartData);
      }
    },

    checkEligibility: function() {
      const cartItems = document.querySelectorAll('.mini-cart__item');
      cartItems.forEach((item, index) => {
        const productTitle = item.querySelector('.product-title a')?.textContent || '';
        const productType = item.getAttribute('data-product-type') || '';
        const lineKey = item.getAttribute('data-line-key') || '';
        const isEligible = item.getAttribute('data-subscription-eligible') === 'true';
        const hasSubscribeUI = !!item.querySelector('.subscribe-save-cart-ui');
      });
    },
    forceEligible: function() {
      const cartItems = document.querySelectorAll('.mini-cart__item');
      cartItems.forEach(item => {
        item.setAttribute('data-subscription-eligible', 'true');
      });
    },
    forceIneligible: function() {
      const cartItems = document.querySelectorAll('.mini-cart__item');
      cartItems.forEach(item => {
        item.setAttribute('data-subscription-eligible', 'false');
      });
    },
    setEligibility: function(lineKey, isEligible) {
      const cartItem = document.querySelector(`[data-line-key="${lineKey}"]`);
      if (cartItem) {
        cartItem.setAttribute('data-subscription-eligible', isEligible ? 'true' : 'false');
      } else {
      }
    },
    toggleTestingMode: function() {
      const currentMode = window.SubscribeSave.testingMode;
      window.SubscribeSave.testingMode = !currentMode;
      injectSubscribeSaveUI();
    },
    fixGentleMicellarEligibility: function() {
      const cartItems = document.querySelectorAll('.mini-cart__item');
      cartItems.forEach(item => {
        const productTitle = item.querySelector('.product-title a')?.textContent || '';
        if (productTitle.toLowerCase().includes('gentle micellar antioxidant cleanser refill')) {
          item.setAttribute('data-subscription-eligible', 'true');
        }
      });
    },
    fixCurrentIssue: function() {
      this.fixGentleMicellarEligibility();
      this.checkEligibility();
    },
    injectSubscribeSaveUIWithEligibilityCheck: injectSubscribeSaveUIWithEligibilityCheck,
    testSubscriptionDetection: function() {
      const cartItems = document.querySelectorAll('.mini-cart__item');
      cartItems.forEach((item, index) => {
        const lineKey = item.getAttribute('data-line-key');
        const isSubscribed = this.checkIfItemIsSubscribed(item);
        const interval = this.getItemInterval(item);
        const properties = Array.from(item.querySelectorAll('[data-property]')).map(p => ({
          key: p.getAttribute('data-property'),
          value: p.textContent
        }));
        const sellingPlan = item.querySelector('input[data-selling-plan]')?.value;
        
        const checkbox = item.querySelector('.subscribe-save-checkbox');
        if (checkbox) {
        }
      });
    },
    clearUserInteractions: function() {
      const checkboxes = document.querySelectorAll('.subscribe-save-checkbox');
      const selects = document.querySelectorAll('.subscribe-dropdown');
      checkboxes.forEach(cb => cb.removeAttribute('data-user-interacted'));
      selects.forEach(s => s.removeAttribute('data-user-interacted'));
    },
    checkIfItemIsSubscribed: checkIfItemIsSubscribed,
    getItemInterval: getItemInterval
  };

  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('subscribe-save-checkbox')) {
      handleSubscribeToggle(e.target);
    } else if (e.target.classList.contains('subscribe-dropdown')) {
      handleIntervalChange(e.target);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:updated', function() {
    window.SubscribeSave.injectSubscribeSaveUI();
  });
})();